<template>
<section class="page-journal">
  <div class="qbk-header">
    <img src="../assets/images/logo-red.svg" alt="">
  </div>
  <div class="qbk-journal-details">
    <div class="qbk-wrap">
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="qbk-jd-main-image">
            <img :src="journal.image" alt="" class="img-fluid w-100">
          </div>
          <div class="qbk-jd-main-content">
            <h1>{{journal.title}}</h1>
            <label>{{journal.date}}</label>
            <div class="qbk-jdmc-content" v-html="journal.content"></div>
            <div class="qbk-jdmc-content">
              <img :src="ji.image" v-for="(ji,jiIndex) in journal.images" :key="`ji-${jiIndex}`" alt="" class="img-fluid">
            </div>
          </div>
          <div class="qbk-jd-share">
            <label>Share :</label>
            <a href="#"><img src="../assets/images/share/fb.png" alt=""></a>
            <a href="#"><img src="../assets/images/share/tw.png" alt=""></a>
            <a href="#"><img src="../assets/images/share/wa.png" alt=""></a>
            <a href="#"><img src="../assets/images/share/g-plus.png" alt=""></a>
          </div>
          <div class="qbk-jd-nav">
            <router-link to="/journal/details">
              <img src="../assets/images/black-arrow-right.svg" alt=""> Prev Article
            </router-link>
            <router-link to="/journal/details">
              Next Article <img src="../assets/images/black-arrow-right.svg" alt="">
            </router-link>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="qbk-jd-related">
            <h1>Latest Post</h1>
            <div class="qbk-jdr-item" v-for="(jtp,index) in otherjournal" :key="'qbk-jtp-item-'+index" v-show="jtp.id != journal.id">
              <router-link to="/journal/details">
                <img :src="jtp.image" alt="" class="img-fluid w-100">
                <h5>{{jtp.title}}</h5>
                <label>{{jtp.date}}</label>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import axios from 'axios'
import {baseUrl} from '../config'
export default {
  name: 'journal',
  data() {
    return {
      hooperSettings: {
        itemsToShow: 1,
        itemsToSlide: 1,
        infiniteScroll: true,
        autoPlay: true,
        playSpeed: 5000,
        vertical: true
      },
      journal : {
        id: null,
        title: null,
        content: null,
        image: null,
        child: null,
        type: null,
        id_parent: null
      },
      otherjournal: []
    };
  },
  methods: {
    loadJournal(){
      let id = this.$route.params.id
      let url = `${baseUrl}/api/post/get`
      let payload = {
        id : id
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        data.images = []
        data.child.map((x)=>{
          switch (x.type) {
            case 'JOURNAL ITEM IMAGES':
              data.images.push(x)
            break;
          }
        })
        this.journal = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    loadJournalOther(){
      let url = `${baseUrl}/api/post`
      let payload = {
        perPage : 4,
        type : 'JOURNAL ITEM'
      }
      axios
      .post(url,payload)
      .then((res)=>{
        let data = res.data.data
        this.otherjournal = data
      })
      .catch((e)=>{
        this.notif('Error',e.message,'error')
      })
    },
    thousand(num) {
      if (num) {
        let num_parts = num.toString().split(",");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return num_parts.join(",");
      } else {
        return 0
      }
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
  },
  mounted(){
    this.loadJournal()
    this.loadJournalOther()
  }
}
</script>
